import { render, staticRenderFns } from "./SpeechPlayerController.vue?vue&type=template&id=8ec916fe&scoped=true"
import script from "./SpeechPlayerController.vue?vue&type=script&lang=js"
export * from "./SpeechPlayerController.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec916fe",
  null
  
)

export default component.exports